import { MaskLine, FadeUp } from "./Reveal";

export const Team = () => (
  <section id="team" data-testid="team-section" className="py-28 md:py-40 hairline-t">
    <div className="max-w-[1440px] mx-auto px-6 md:px-12 grid md:grid-cols-12 gap-12 md:gap-16 items-center">
      <div className="md:col-span-5">
        <FadeUp delay={0.15}>
          <div className="relative aspect-[4/5] overflow-hidden">
            <img
              src="/assets/chris-walden.jpg"
              alt="Chris Walden, owner of Vinedresser Vineyard Management, standing in a vineyard"
              loading="lazy"
              decoding="async"
              className="absolute inset-0 w-full h-full object-cover object-[center_30%]"
            />
          </div>
        </FadeUp>
      </div>
      <div className="md:col-span-7">
        <FadeUp>
          <p className="text-[11px] tracking-[0.32em] uppercase text-[#B89B67] font-semibold mb-10">Leadership</p>
        </FadeUp>
        <h2 className="font-display font-light text-[#1A3626] text-5xl md:text-6xl lg:text-7xl leading-[1.02] tracking-tight">
          <MaskLine delay={0.1}>Chris Walden</MaskLine>
        </h2>
        <FadeUp delay={0.3}>
          <p className="text-[11px] tracking-[0.28em] uppercase text-[#B89B67] font-semibold mt-4">Owner</p>
        </FadeUp>
        <FadeUp delay={0.4} className="mt-10 space-y-6 max-w-[56ch]">
          <p data-testid="owner-bio" className="text-base md:text-lg leading-relaxed text-[#2C2926]/80">
            Chris Walden owns and operates Vinedresser Vineyard Management. He has spent 20 years farming high-end vineyards across Napa and Sonoma counties, and he still works directly with every client, from the first walk of a property through each harvest.
          </p>
          <p className="text-base md:text-lg leading-relaxed text-[#2C2926]/80">
            Chris and his wife Melissa are raising their three daughters in the agricultural community that raised him. For Chris, farming is as much about the next generation as it is about the next vintage: a passion for teaching his daughters the importance of sustainable stewardship of the land.
          </p>
        </FadeUp>
      </div>
    </div>
  </section>
);
